import ComponentHelper from '../../../../supers/ComponentHelper';
import React from 'react';
import InputField from '../../../../components/input-field/InputField';
import ValidationService from '../../../../services/ValidationService';
import { view } from 'react-easy-state';
import MultiStepModal from '../../../../components/multi-step-modal/MultiStepModal';
import _ from 'lodash';
import './create-entity-modal.css';
import RESTService from '../../../../services/RESTService';
import RoutingService from '../../../../services/RoutingService';
import EntityFieldPicker from '../entity-field-picker/EntityFieldPicker';
import Spinner from '../../../../components/spinner/Spinner';
const VS = new ValidationService();
const connect = new RESTService();
const RS = new RoutingService();

// MODEL = store({
//     displayName: '',
//     fieldName: '',
//     fieldType: 'string',
//     arrFieldType: 'string',
//     relation: '',
//     schema: {
//         properties: {}
//     }
// });

class CreateEntityModal extends ComponentHelper {
	constructor(props) {
		super(props);
		this.autoBindAll(this, null, true);
		this.setInitialData(props);
	}

	setInitialData(props) {
		this.data.loading = false;
		this.data = props.formData;
		this.data.entities = props.entities;
	}

	// Clear component state when modal is re-open
	componentWillReceiveProps(nextProps) {
		if (!this.props.isOpen && nextProps.isOpen) {
			this.observe(() => {
				this.setInitialData(nextProps);
			});
		}
	}

	onClose() {
		this.props.onClose();
	}

	onNameChange(evt) {
		if (VS.validateField(evt.target.value)) {
			this.data[evt.target.name] = evt.target.value;
		}
	}

	onDescChange(evt) {
		this.data.schema.title = evt.target.value;
	}

	validateStep1() {
		if (this.data && this.data.displayName.length > 0) {
			return true;
		}
		return false;
	}

	validateStep2() {
		if (Object.keys(this.data.schema.properties).length > 0) {
			return true;
		}
		return false;
	}

	onSaveEntity() {
		let { displayName, schema } = this.data;
		let entity = { displayName, schema: JSON.parse(JSON.stringify(schema)) };
		this.data.loading = true;
		connect
			.createEntity(entity)
			.then(res => {
				RS.showSuccess();
				this.data.loading = false;
				this.props.onComplete(res.data);
			})
			.catch(err => {
				this.data.loading = false;
				RS.smartError(err);
			});
	}

	getSteps() {
		let { displayName, schema, loading } = this.data;
		if (loading) {
			return {
				Saving: {
					validator: null,
					onNext: null,
					text: '',
					nextText: '',
					loading: true,
					content: <Spinner text="Saving..." />
				}
			};
		}
		return {
			Name: {
				validator: this.validateStep1,
				onNext: null,
				text: 'What should we call this entity?',
				nextText: 'Next',
				content: (
					<div className="modal-body">
						<InputField
							label="Entity Name"
							name="displayName"
							type="text"
							value={displayName}
							handleChange={this.onNameChange}
							placeholder="Enter a unique name"
							required
							autoFocus
						/>
						<InputField
							label="Description"
							name="desc"
							type="text"
							value={schema.title ? schema.title : ''}
							handleChange={this.onDescChange}
							placeholder="Enter a short description of this entity"
						/>
					</div>
				)
			},
			Fields: {
				validator: this.validateStep2,
				onNext: this.onSaveEntity,
				text: 'What fields does it contain?',
				nextText: 'Save',
				content: this.buildFieldContent()
			}
		};
	}

	removeField(evt) {
		delete this.data.schema.properties[evt.target.dataset.field];
	}

	buildFieldContent() {
		let {
			schema: { properties }
		} = this.data;
		let fields = [];
		_.forEach(Object.keys(properties), field => {
			fields.push(
				<div className="field-row hbox vcenter" key={field + '-key'}>
					<div className="field-name ellipse">{field}</div>
					<div className="field-type grow-1">
						{_.upperFirst(properties[field].type) + (properties[field].type === 'array' ? ` of ${properties[field].items.type}` : '')}
					</div>
					<i className="mdi mdi-close" title="Remove" data-field={field} onClick={this.removeField} />
				</div>
			);
		});
		if (fields.length <= 0) {
			fields.push(
				<div className="empty-msg" key="empty-msg-key-0">
					Enter a name and type above to get started.
				</div>
			);
		}
		return (
			<div className="field-ctn">
				<EntityFieldPicker formData={this.data} entities={this.data.entities} />
				<div className="fields-list">{fields}</div>
			</div>
		);
	}

	render() {
		let { isOpen } = this.props;
		return (
			<MultiStepModal isOpen={isOpen} onClose={this.onClose} className="create-entity-modal" title={'Create New Entity'} steps={this.getSteps()} />
		);
	}
}
export default view(CreateEntityModal);



// WEBPACK FOOTER //
// ./src/views/entities-panel/entity-list/entity-modal/CreateEntityModal.js